import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

export const getPercent = (
  price: string | number,
  reference: string | number,
) => {
  const number = typeof price === 'string' ? parseInt(price, 10) : price
  const referencedNumber =
    typeof reference === 'string' ? parseInt(reference, 10) : reference

  return number < referencedNumber
    ? Math.ceil(((number - referencedNumber) / referencedNumber) * 100)
    : null
}

export const logger = {
  info(
    err: Error,
    {
      component: { name: componentName, props },
      routeName,
    }: {
      component: { name: string; props: Record<string, unknown> }
      routeName: string
    },
  ) {
    const globalLogger = useLogger()
    const owner = 'S&R'
    const level = 'Error'
    const message = `[${owner}][${level}][${componentName}]`
    const attributes = {
      componentName,
      props,
      routeName,
      details: {
        message: err?.message,
        stack: err?.stack,
      },
      err,
    }

    globalLogger.info(message, attributes)
  },
}

export const saveProductInfos = ({
  id,
  price,
  source,
  reviewRating,
}: {
  id: string
  price: string
  source: string
  reviewRating?: string
}) => {
  if (window.sessionStorage) {
    window.sessionStorage.setItem(
      id,
      JSON.stringify({ price, source, reviewRating }),
    )
  }
}

export const getProductInfos = (id: string) => {
  if (window.sessionStorage) {
    const item = window.sessionStorage.getItem(id)

    return item ? JSON.parse(item) : {}
  }

  return {}
}
